module.exports = __webpack_public_path__ + "img/Trippen.453815d4.png";